import {executeRequest} from "./request";
import {DOMAIN_URL, EMPLOYEE_SERVICE} from "./configURL";

export function getInterlocutorsByCustomer(customer_code) {
	const params = {
		customer_code
	}

	return new Promise((reject, resolve) => {
		executeRequest(
			DOMAIN_URL + EMPLOYEE_SERVICE.GET_INTERLOCUTORS_BY_CUSTOMER,
			params,
			reject,
			resolve
		);
	});
}

export function setInterlocutor(interlocutor_id) {
	const params = {
		interlocutor_id
	}

	return new Promise((reject, resolve) => {
		executeRequest(
			DOMAIN_URL + EMPLOYEE_SERVICE.SET_INTERLOCUTOR,
			params,
			reject,
			resolve
		);
	});
}


export function ping() {

	return new Promise((reject, resolve) => {
		executeRequest(
			DOMAIN_URL + EMPLOYEE_SERVICE.PING,
			null,
			reject,
			resolve,
		);
	});
}

export function unsetInterlocutor() {
	return new Promise((reject, resolve) => {
		executeRequest(
			DOMAIN_URL + EMPLOYEE_SERVICE.UNSET_INTERLOCUTOR,
			null,
			reject,
			resolve
		);
	});
}



// WEBPACK FOOTER //
// ./src/js/webAPI/employeeService.js